import React from "react";
import { withTranslation } from "react-i18next";
import { Chart, Interval } from "bizcharts";

class ChartLineLeads extends React.Component {
  state = {};

  render() {
    const { t } = this.props;

    let currentTasks = [];
    for (const [key, value] of Object.entries(this.props.currentYearTasks)) {
      currentTasks.push({ name: key, hours_worked: value });
    }

    return (
      <div>
        <p className="pStyle" style={{ textAlign: "center" }}>
          {t(
            "dashboard.chart_line_leads.new_leads",
            "Hours worked per lead this year."
          )}
        </p>
        <Chart
          height={400}
          autoFit
          data={currentTasks}
          interactions={["element-active"]}
          padding={[30, 30, 30, 50]}
        >
          <Interval position="name*hours_worked" />
        </Chart>
      </div>
    );
  }
}

export default withTranslation()(ChartLineLeads);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/ChartLineLeads.js